import { productInventoryEndpoints } from '@services/productInventory';
import { useQueryClient } from '@tanstack/react-query';

export const useInvalidateQueries = () => {
  const queryClient = useQueryClient();

  const invalidateContentProcessingJobsQueries = async () => {
    queryClient.invalidateQueries({ queryKey: [productInventoryEndpoints.contentProcessing.root] });
  };

  const invalidateSalesBOMJobQuery = async () => {
    queryClient.invalidateQueries({ queryKey: [productInventoryEndpoints.contentProcessing.sbom] });
  };

  const invalidatePartCategoriesJobQuery = async () => {
    queryClient.invalidateQueries({ queryKey: [productInventoryEndpoints.contentProcessing.partsCategories] });
  };

  const invalidateKitsJobQuery = async () => {
    queryClient.invalidateQueries({ queryKey: [productInventoryEndpoints.contentProcessing.kits] });
  };

  /* istanbul ignore next - this is currently uncovered by jest as where it's used it's better covered with e2e tests */
  const invalidateConfigurationsQuery = async () => {
    queryClient.invalidateQueries({ queryKey: [productInventoryEndpoints.configurations] });
  };

  const invalidatePartTreeQuery = async () => {
    queryClient.invalidateQueries({ queryKey: ['partTree'] });
  };

  return {
    invalidateContentProcessingJobsQueries,
    invalidateSalesBOMJobQuery,
    invalidatePartCategoriesJobQuery,
    invalidateKitsJobQuery,
    invalidatePartTreeQuery,
    invalidateConfigurationsQuery,
  };
};
